import { fixMojibake } from './utils'

// El record de los grupos del club en un torneo INTERNO.
//
// No es una tabla de posiciones, y la pestana ya no se llama asi (2026-09-04): en el
// torneo interno el club captura SOLO sus juegos, asi que los partidos entre rivales no
// existen aqui y nadie puede armar la tabla de la liga. Lo que si hay es el record de
// cada grupo del club, con los marcadores que capturo. Por eso no hay "#" ni PTS: los
// grupos del club juegan en categorias distintas y ordenarlos por puntos entre si era
// inventar una clasificacion que no existe. Van por nombre.
export const filasDeRecord = (inscripciones = []) =>
  (inscripciones || [])
    .filter((i) => i && i.activo !== false)
    .map((i) => ({
      ...i,
      nombre: fixMojibake(i.grupos?.nombre_del_grupo || 'Grupo'),
      diferencia: (i.puntos_favor || 0) - (i.puntos_contra || 0),
    }))
    .sort((a, b) => a.nombre.localeCompare(b.nombre))

// Sin juegos terminados no hay record que ensenar.
export const hayRecord = (filas = []) => (filas || []).some((f) => (f.partidos_jugados || 0) > 0)
